export default "__VITE_ASSET__CBfZLSSM__"